import { Api } from "@/services/api.js";

class DDwallet extends Api
{
  constructor() {
    super();
  }

  getAccountLinkCheck(merchantId = '', userId = '') {
    const config = {
      method: 'GET',
      url: `${this.apiHost}/identities/v2/merchants/${merchantId}/members/${userId}/pms/ddpay/linked-account`,
      headers: {},
    };

    return this.$http(config);
  }

  postAccountLink(merchantId = '', userId = '') {
    const config = {
      method: 'POST',
      url: `${this.apiHost}/identities/v2/merchants/${merchantId}/members/${userId}/account-link/link-uri`,
      headers: {},
      data: {
        vendorCode: 'ddpay',
        version: 'v2',
        continueUrl: process.env.VUE_APP_DDWALLET_CONTINUE_URL
      }
    };

    return this.$http(config);
  }
}

export const ddwallet = new DDwallet();